import { AiAgentUiCommand } from "./ai-agent-ui-command.types";

/** Pending Excel (or other) download attached to an assistant chat line — user must click. */
export interface AiAgentPendingDownload {
  id: string;
  label: string;
  command: AiAgentUiCommand;
}

const LIST_LABELS: Record<string, string> = {
  orders: "Orders",
  preorders: "Preorders",
  reservations: "Reservations",
  gifts: "Gifts",
  shipping: "Shipping",
  payments: "Payments",
  payouts: "Payouts",
  calendar: "Calendar",
  receipts: "Receipts",
};

export function isExportListExcelCommand(data: any): boolean {
  return !!data && String(data.type || "") === "exportListExcel";
}

export function pendingDownloadFromUiCommand(data: any): AiAgentPendingDownload | null {
  if (!isExportListExcelCommand(data)) {
    return null;
  }
  const list = data.list != null ? String(data.list).trim() : "";
  if (!list) {
    return null;
  }
  const filters =
    data.filters && typeof data.filters === "object"
      ? (data.filters as Record<string, unknown>)
      : {};
  const command: AiAgentUiCommand = {
    type: "exportListExcel",
    list,
    filters,
  };
  return {
    id: `dl-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    label: buildExportDownloadLabel(list, filters),
    command,
  };
}

export function buildExportDownloadLabel(
  list: string,
  filters: Record<string, unknown>
): string {
  const base = LIST_LABELS[list] || list;
  const range = formatFilterDateRange(filters);
  return range
    ? `Download Excel — ${base} (${range})`
    : `Download Excel — ${base}`;
}

function formatFilterDateRange(filters: Record<string, unknown>): string {
  const start =
    pickDate(filters, "startTime") ||
    pickDate(filters, "startDate") ||
    pickDate(filters, "dateFrom");
  const end =
    pickDate(filters, "endTime") ||
    pickDate(filters, "endDate") ||
    pickDate(filters, "dateTo");
  if (start && end) {
    return start === end ? start : `${start} – ${end}`;
  }
  return start || end || "";
}

function pickDate(filters: Record<string, unknown>, key: string): string {
  const v = filters[key];
  if (v == null) {
    return "";
  }
  const s = String(v).trim();
  return s.length >= 10 ? s.slice(0, 10) : s;
}
